// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e4fF","content":"styles_content__38OTR"};